import {useSessionStore, useAppStore} from '@/stores'
import {useMeetingStore} from '@/stores'
import {useEventBus} from '@vueuse/core'

export const useParticipantDisjoinedCallback = () => {
  const session = useSessionStore()
  const app = useAppStore()

  useEventBus('session:participant:disjoined').on((event: any) => {
    const {id: participantId, isAlreadyDisJoined} = event
    const participant = session.getParticipant(participantId)

    if (participant) {
      if (participant.party === 'client' && !session.sessionFailed) {
        useMeetingStore().toLobby()
        session.removeParticipant(participantId)
      } else if (participant.party === 'assistant' && !session.sessionFailed && isAlreadyDisJoined) {
        app.goToEnd()
        session.removeParticipant(participantId)
      } else {
        session.removeParticipant(participantId)
      }
    }
  })
}
